import { Offer } from 'graphql/models/extended';
import { DocumentVersionInput } from 'graphql/models/generated';

export function extractDocVersion(
  offer: Pick<Offer, 'documentId' | 'revision'>
): DocumentVersionInput {
  return {
    documentId: offer.documentId,
    revision: offer.revision
  };
}

export function extractDocVersionString(
  offer: Pick<Offer, 'documentId' | 'revision'>,
  separator = '/'
): string {
  return offer.documentId + separator + offer.revision;
}
